// import packages
import gql from "graphql-tag"

// export gqls
export const GET_PRICEBOOKS = gql`
  query PriceBooks($take: Int, $skip: Int, $input: PriceBookFilterInput) {
    priceBooks(take: $take, skip: $skip, input: $input) {
      total
      data {
        id
        price
        product {
          id
          productNumber
          description
        }
      }
    }
  }
`

export const SUM_PRICEBOOKS = gql`
  query PriceBooks($input: PriceBookFilterInput) {
    priceBooks(take: 0, input: $input) {
      total
    }
  }
`

export const GET_TABLE_FIELDS = gql`
  query PriceBookFields {
    priceBookFields @client {
      name
      title
      order
      show
    }
  }
`

export const CREATE_ORDER_WITH_DETAIL = gql`
  mutation CreateOrderWithDetail($input: OrderCreateInput!, $detail: String!) {
    createOrderWithDetail(input: $input, detail: $detail) {
      id
      orderNumber
      orderDetails {
        id
        unitPrice
        quantity
      }
    }
  }
`
